import TemplateFieldDTO from "./TemplateFieldDTO";

export type Field = TemplateFieldDTO;

export enum OrderItemLabelTemplateSortType {
    BY_EXTERNAL_ID = "BY_EXTERNAL_ID",
    BY_STOCK_NO = "BY_STOCK_NO",
    BY_TITLE = "BY_TITLE",
    RAW = "RAW",
}

export enum OrderItemLabelPrintType {
    /**按orderItem内的数量打印 */
    QUANTITY = "QUANTITY",
    /**按orderItem的种类打印 */
    SKU = "SKU",
}
export default interface OrderItemLabelTemplateDTO {
    bindingPrinter: string;

    bindingShopIds: string;

    companyId: number;

    deleted: boolean;

    fields: TemplateFieldDTO[];

    height: number;

    id: number;

    index: number;

    isSystemTemplate: boolean;

    name: string;

    needInterval: boolean;

    offsetLeft: number;

    offsetTop: number;

    orderItemSortType: OrderItemLabelTemplateSortType;

    picture: string;

    printTemplateUrl: string;

    shopId: number;

    thumbnail: string;

    width: number;

    printType: OrderItemLabelPrintType;

    lastUpdated: string;
}
